import * as React from "react";
import { View, Image, TouchableOpacity } from 'react-native';

const HomeIcon = ({active, onPress}) => {

    return <TouchableOpacity onPress={onPress}>
        <Image source={active ? require('../../assets/images/layout/bottomMenu/home-active.png') : require('../../assets/images/layout/bottomMenu/home.png')} />
    </TouchableOpacity>
}

const CarIcon = ({active, onPress}) => {
    return <TouchableOpacity onPress={onPress}>
        <Image source={active ? require('../../assets/images/layout/bottomMenu/pickup-service-active.png') : require('../../assets/images/layout/bottomMenu/pickup-service.png')} />
    </TouchableOpacity>
}

export function BottomMenu(props) {
    return <View style={{ backgroundColor: 'white', height: 100, borderRadius: 100, marginBottom: -50, bottom: 0, width: '100%', position: 'absolute', overflow: 'hidden' }}>
        <View style={{flex: 1, flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}>
            <HomeIcon onPress={() => props.setCurrentPage(0)} active={props.currentPage == 0} />
            <CarIcon onPress={() => props.setCurrentPage(1)} active={props.currentPage == 1} />
        </View>
        <View style={{flex: 1}} />
    </View>
}